export const EMPTY_BILLING_MODAL_CONTEXT = Object.freeze({
  billId: undefined,
  poNumber: undefined,
  poStatus: undefined,
  poSeedData: null,
  poAmount: undefined,
});

export const createBlankBillingModalContext = () => ({
  ...EMPTY_BILLING_MODAL_CONTEXT,
});

export const createEditBillingModalContext = (billId) => ({
  ...createBlankBillingModalContext(),
  billId,
});

export const createPoBillingModalContext = ({
  poNumber,
  poStatus,
  poSeedData,
  poAmount,
}) => ({
  ...createBlankBillingModalContext(),
  poNumber,
  poStatus,
  poSeedData,
  poAmount,
});

export const getBillingModalInitializationKey = ({
  billId,
  poNumber,
  poSeedData,
} = {}) => {
  if (billId != null && billId !== "") return `edit:${billId}`;

  const poIdentity = poSeedData?.poId ?? poSeedData?.poNumber ?? poNumber;
  if (poIdentity != null && poIdentity !== "") return `po:${poIdentity}`;

  return "blank:new";
};
